import { Box, Button, Flex, FormControl, FormErrorMessage, FormLabel, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text, Textarea, useToast } from '@chakra-ui/react';

import { useFormik } from "formik";

import { useEffect, useRef, useState } from "react";
import trainerRegistration from '../../../services/trainer/trainerRegistration';
import { Years } from '../../../utils/years';
//const EduQualificationModal : React.FC<any> = ({ isOpenEducationQualification, onCloseEducationQualification, educationQualification = false }: { educationQualification: boolean, isOpenEducationQualification: any, onCloseEducationQualification: any, }) => {
export const WorkExperienceModal: React.FC<any> = ({ isOpenworkXperience, onCloseWorkXperience, isWorkXperience = false, reload }: { isOpenworkXperience: any, onCloseWorkXperience: any, isWorkXperience: boolean, reload: any }) => {
  const [gender, setGender] = useState<any[]>([]);
  const [years, setYears] = useState<any[]>([]);
  const [loading, isLoading] = useState(false)
  const toast = useToast();

  useEffect(() => {

    setYears(Years())


    const maingender = [{
      id: '1',
      title: 'male'
    },
    {
      id: '2',
      title: 'female'
    }
    ]
    setGender(maingender)

  }, []);

  const cancelRef = useRef().current;
  const formik = useFormik({
    validate: (values: any) => {
      // const errors: any = {};
      // if (!values.firstName) {
      //   errors.firstName = 'First Name is required'
      // }
      // if (!values.lastName) {
      //   errors.lastName = 'Last Name is required'
      // }
      // if (!values.country) {
      //   errors.country = 'Country is required'
      // }
      // if (!values.role) {
      //   errors.role = 'Role is required'
      // }
      // if (!values.office) {
      //   errors.office = 'Office is required'
      // }
      // return errors;
    },
    initialValues: {
      jobtitle: "",
      sector: '',
      orgnisationName: '',
      organisationAddress: '',
      organisationNo: '',
      startYear: '',
      endYear: '',
      description: '',

    },
    onSubmit: async (values) => {
      const workExperience: any = {
        title: values.jobtitle,
        organization_name: values.jobtitle,
        organization_phone: values.organisationNo,
        organization_address: values.organisationAddress,
        sector: values.sector,
        started: values.startYear,
        ended: values.endYear
      }
      try {
        const basicResponse = await trainerRegistration.updateUserExperience(workExperience);
        if (basicResponse) {
          onCloseWorkXperience()
          formik.resetForm()
          
          toast({
            title: "Registration",
            description: "Work experience added",
            status: "success",
          })
          reload()

        }
      } catch (error) {
        
        toast({
          title: "Registration",
          description: "something went wrong, try again later",
          status: "success",
        })
      }
    }
  })

  return (
    <>
      <Modal
        isOpen={isOpenworkXperience && isWorkXperience}
        onClose={onCloseWorkXperience}
        scrollBehavior="inside"
        closeOnOverlayClick={true}
        size="lg"
        isCentered
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={3}>
          <ModalHeader>
            <Flex justifyContent='center'>
              <Box>
                <Flex justifyContent='center'>
                  <Text mx='auto' color="#353535" fontSize="28px" fontWeight='800'>
                    Add  Work Experience
                  </Text>
                </Flex>
              </Box>
            </Flex>

          </ModalHeader>
          <ModalCloseButton size="sm" />

          <ModalBody>
            <Box mt={4}>

              <form onSubmit={formik.handleSubmit} >

                <FormControl mb='26px' isInvalid={(formik.errors.jobtitle && formik.touched.jobtitle) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize='14px'>Job Title</FormLabel>
                  <Input bg="inputText.500" placeholder="Enter Job Title" value={formik.values.jobtitle} name="jobtitle" onChange={formik.handleChange} fontSize='14px' />
                  <FormErrorMessage fontSize={12} >{formik.errors.jobtitle}</FormErrorMessage>
                </FormControl>
                <FormControl mb='26px' isInvalid={(formik.errors.sector && formik.touched.sector) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize='14px'>Sector</FormLabel>
                  <Input bg="inputText.500" placeholder="Enter sector" value={formik.values.sector} name="sector" onChange={formik.handleChange} fontSize='14px' />

                  <FormErrorMessage fontSize={12} >{formik.errors.sector}</FormErrorMessage>
                </FormControl>
                <FormControl mb='26px' isInvalid={(formik.errors.orgnisationName && formik.touched.orgnisationName) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize='14px'>Organisation Name</FormLabel>
                  <Input bg="inputText.500" placeholder="Enter Organisation's Name" value={formik.values.orgnisationName} name="orgnisationName" onChange={formik.handleChange} fontSize='14px' />
                  <FormErrorMessage fontSize={12} >{formik.errors.orgnisationName}</FormErrorMessage>
                </FormControl>
                <FormControl mb='26px' isInvalid={(formik.errors.organisationNo && formik.touched.organisationNo) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize='14px'>Organisation Telephone</FormLabel>
                  <Input bg="inputText.500" placeholder="Enter Organisation's No" value={formik.values.organisationNo} name="organisationNo" onChange={formik.handleChange} fontSize='14px' />
                  <FormErrorMessage fontSize={12} >{formik.errors.organisationNo}</FormErrorMessage>
                </FormControl>


                <FormControl mb='26px' isInvalid={(formik.errors.organisationAddress && formik.touched.organisationAddress) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize='14px'>Organisation Address</FormLabel>
                  <Input bg="inputText.500" placeholder="Enter Organisation's Address" value={formik.values.organisationAddress} name="organisationAddress" onChange={formik.handleChange} fontSize='14px' />
                  <FormErrorMessage fontSize={12} >{formik.errors.organisationAddress}</FormErrorMessage>
                </FormControl>


                <FormControl mb='26px' isInvalid={(formik.errors.startYear && formik.touched.startYear) ? true : false}>
                  <FormLabel fontWeight="700" color="#616161" fontSize='14px'>Start Year</FormLabel>
                  <Select variant="outline" bg="inputText.500" size="sm" placeholder="Select year" value={formik.values.startYear} name="startYear" onChange={formik.handleChange} fontSize='14px' color="brand.subtitle" >
                    {
                      years.map((each, index) => (<option key={index} value={each}> {each} </option>)
                      )
                    }
                  </Select>
                  <FormErrorMessage fontSize={12} >{formik.errors.startYear}</FormErrorMessage>
                </FormControl>
                <FormControl mb='26px' isInvalid={(formik.errors.endYear && formik.touched.endYear) ? true : false}>
                  <FormLabel fontWeight="700" color="#616161" fontSize='14px'>End Year</FormLabel>
                  <Select variant="outline" bg="inputText.500" size="sm" placeholder="Select year" value={formik.values.endYear} name="endYear" onChange={formik.handleChange} fontSize='14px' color="brand.subtitle" >
                    {
                      years.map((each, index) => (<option key={index} value={each}> {each} </option>)
                      )
                    }
                  </Select>
                  <FormErrorMessage fontSize={12} >{formik.errors.endYear}</FormErrorMessage>
                </FormControl>
                <FormControl id="description" isInvalid={(formik.errors.description && formik.touched.description) ? true : false}>
                  <FormLabel fontWeight="700" color="#616161" fontSize='14px'>Brief Job Description </FormLabel>
                  <Textarea
                    p={4}
                    bg="inputText.500"
                    fontSize={12}
                    size="sm"
                    minH="100px"
                    name="description"
                    onChange={formik.handleChange}
                    value={formik.values.description}
                  />
                  <FormErrorMessage fontSize={12} >{formik.errors.description}</FormErrorMessage>
                </FormControl>




                <Flex mt={12} justifyContent="end">
                  <HStack>
                    {/* <Button size="sm" px={6} fontSize={12} ref={cancelRef} onClick={() => onCloseWorkXperience()}>
                      Cancel
                    </Button> */}
                    <Button colorScheme="red" type="submit" isLoading={formik.isSubmitting}
                      size="sm" px={6} fontSize={12} >SAVE CHANGES</Button>
                  </HStack>
                </Flex>
              </form>

            </Box>


          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

